<template>
  <div class="member">
    <div class="row align-items-center">
      <div class="col">
        <section-header class="mt-5 mb-5" title="我的帳號" subtitle="My Account"/>
      </div>
      <div class="col-auto">
        <button class="btn btn-outline-dark mt-3 mb-3 ps-3 pe-3" @click="onSignOutClicked">登出</button>
      </div>
    </div>
    <div class="btn-group w-100 position-relative" role="group">
      <template v-for="(frame, index) in frames">
        <input :key="`input-${index}`" :id="frame.id" type="radio" name="member-menu" class="btn-check" autocomplete="off" :checked="menu === frame.id">
        <div :key="`label-${index}`" :for="frame.id" class="btn btn-outline-dark pt-3 pb-3" @click="onMenuSelected(frame.id)">
          <label>{{ frame.name }}</label>
          <i :key="`icon-${index}`" class="bi bi-circle-fill position-absolute top-0 loft-text-highlight pt-3 ps-1 icon-inform" v-if="frame.id === 'message'" v-show="$route.path !== '/w/member/message' && hasUnreadConsults"></i>
        </div>
      </template>
    </div>
    <div class="mt-5">
      <component :is="frame.component" v-if="user"/>
    </div>
  </div>
</template>

<script>
import SectionHeader from '@/components/SectionHeader.vue'
import MemberOrder from '@/components/Member/MemberOrder.vue'
import MemberInfo from '@/components/Member/MemberInfo.vue'
// import MemberStatus from '@/components/Member/MemberStatus.vue'
import MemberAddr from '@/components/Member/MemberAddr.vue'
import MemberMessage from '@/components/Member/MemberMessage.vue'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Member',
  components: {
    SectionHeader,
    MemberOrder,
    MemberInfo,
    // MemberStatus,
    MemberAddr,
    MemberMessage
  },
  data: function () {
    return {
      frames: [
        { id: 'order', name: '訂單記錄', component: MemberOrder },
        { id: 'info', name: '會員資料', component: MemberInfo },
        // { id: 'status', name: '會員狀態', component: MemberStatus },
        { id: 'addr', name: '收貨地址', component: MemberAddr },
        { id: 'message', name: '訊息', component: MemberMessage }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'hasUnreadConsults'
    ]),
    menu: function () {
      return this.$route.params.menu
    },
    frame: function () {
      var ret = null
      if (this.menu) {
        var self = this
        ret = this.frames.find(e => e.id === self.menu)
      }
      return ret
    }
  },
  watch: {
    menu: function (value) {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
    }
  },
  methods: {
    ...mapMutations([
      'signOut'
    ]),
    onMenuSelected: function (menu) {
      this.$router.push(`/w/member/${menu}`)
    },
    onSignOutClicked: function () {
      this.signOut()
    }
  }
}
</script>

<style scoped>
.username {
  font-size: 2rem;
  font-family: 'Noto Serif TC', serif;
  font-weight: 700;
}
.email {
  font-size: 1.125rem;
}
.title {
  font-size: 1.3rem;
  font-weight: 500;
}
.col.title {
  font-weight: 400;
}
.content {
  font-weight: 500;
}
.icon-inform {
  font-size: 12px;
  z-index: 10;
  scale: 0.75;
}
@media screen and (min-width: 768px) {
  .member .loft-col:last-child {
    border-left: 1px solid;
    border-color: var(--bs-secondary);
  }
}
</style>
